import {
  PRODUCT_FAMILY_SA,
  PRODUCT_FAMILY_DEALSHIELD,
} from '../../constants/productFamily';

// ---------------------------------------------------------------------------
// Active Guarantee Purchases  (>25 records so pagination is demonstrable)
// ---------------------------------------------------------------------------
export const mockGuaranteePurchases = [
  {
    id: 'gp-1',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-01T09:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 350,
      paymentKind: 'Invoice',
      externalId: 'EXT-001',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 500,
      product: { name: 'DealShield 360, 21 days, 500 miles' },
      vehicleInformation: {
        vin: '1HGBH41JXMN109186',
        make: 'Honda',
        model: 'Accord',
        year: 2023,
        odometerReading: 15000,
      },
      auctionInformation: {
        locationInitials: 'MAN',
        dealerNumber: '11001',
        vehiclePurchasePrice: 28500,
        saleNumber: '1001',
        laneNumber: '3',
        runNumber: '10',
      },
    },
  },
  {
    id: 'gp-2',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-02T10:15:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 400,
      paymentKind: 'Credit Card',
      externalId: 'EXT-002',
      leftLot: true,
      daysSelected: 30,
      milesSelected: 750,
      product: { name: 'DealShield 360, 30 days, 750 miles' },
      vehicleInformation: {
        vin: '2T1BURHE0JC048910',
        make: 'Toyota',
        model: 'Corolla',
        year: 2022,
        odometerReading: 22000,
      },
      auctionInformation: {
        locationInitials: 'DAL',
        dealerNumber: '11002',
        vehiclePurchasePrice: 18000,
        saleNumber: '1002',
        laneNumber: '1',
        runNumber: '5',
      },
    },
  },
  {
    id: 'gp-3',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-03T08:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 275,
      paymentKind: 'Invoice',
      externalId: 'EXT-003',
      leftLot: false,
      daysSelected: 14,
      milesSelected: 300,
      product: { name: 'Seller Assurance 14 days' },
      vehicleInformation: {
        vin: '3VWFE21C04M000001',
        make: 'Volkswagen',
        model: 'Jetta',
        year: 2021,
        odometerReading: 31000,
      },
      auctionInformation: {
        locationInitials: 'ATL',
        dealerNumber: '11003',
        vehiclePurchasePrice: 14500,
        saleNumber: '1003',
        laneNumber: '2',
        runNumber: '8',
      },
    },
  },
  {
    id: 'gp-4',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-04T11:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 500,
      paymentKind: 'Invoice',
      externalId: 'EXT-004',
      leftLot: false,
      daysSelected: 45,
      milesSelected: 1000,
      product: { name: 'DealShield 360, 45 days, 1000 miles' },
      vehicleInformation: {
        vin: '1N4AL3AP7JC232028',
        make: 'Nissan',
        model: 'Altima',
        year: 2023,
        odometerReading: 8500,
      },
      auctionInformation: {
        locationInitials: 'MAN',
        dealerNumber: '11004',
        vehiclePurchasePrice: 22000,
        saleNumber: '1004',
        laneNumber: '4',
        runNumber: '15',
      },
    },
  },
  {
    id: 'gp-5',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-05T09:45:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 200,
      paymentKind: 'Credit Card',
      externalId: 'EXT-005',
      leftLot: false,
      daysSelected: 7,
      milesSelected: 200,
      product: { name: 'Seller Assurance 7 days' },
      vehicleInformation: {
        vin: '5FNRL5H61GB013175',
        make: 'Honda',
        model: 'Odyssey',
        year: 2020,
        odometerReading: 45000,
      },
      auctionInformation: {
        locationInitials: 'CHI',
        dealerNumber: '11005',
        vehiclePurchasePrice: 31000,
        saleNumber: '1005',
        laneNumber: '3',
        runNumber: '22',
      },
    },
  },
  {
    id: 'gp-6',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-06T14:00:00Z',
    expireGuarantee: true,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'expired',
      guaranteePrice: 320,
      paymentKind: 'Invoice',
      externalId: 'EXT-006',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 500,
      product: { name: 'DealShield 360, 21 days, 500 miles' },
      vehicleInformation: {
        vin: 'JN8AT2MT4JW468870',
        make: 'Nissan',
        model: 'Rogue',
        year: 2022,
        odometerReading: 19000,
      },
      auctionInformation: {
        locationInitials: 'PHX',
        dealerNumber: '11006',
        vehiclePurchasePrice: 27000,
        saleNumber: '1006',
        laneNumber: '5',
        runNumber: '3',
      },
    },
  },
  {
    id: 'gp-7',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-07T13:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 250,
      paymentKind: 'Invoice',
      externalId: 'EXT-007',
      leftLot: false,
      daysSelected: 14,
      milesSelected: 300,
      product: { name: 'Seller Assurance 14 days' },
      vehicleInformation: {
        vin: '1FTFW1ET2DFA52428',
        make: 'Ford',
        model: 'F-150',
        year: 2021,
        odometerReading: 37000,
      },
      auctionInformation: {
        locationInitials: 'HOU',
        dealerNumber: '11007',
        vehiclePurchasePrice: 38000,
        saleNumber: '1007',
        laneNumber: '2',
        runNumber: '7',
      },
    },
  },
  {
    id: 'gp-8',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-08T08:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 450,
      paymentKind: 'Credit Card',
      externalId: 'EXT-008',
      leftLot: true,
      daysSelected: 30,
      milesSelected: 500,
      product: { name: 'DealShield 360, 30 days, 500 miles' },
      vehicleInformation: {
        vin: '1G1ZD5ST2JF255348',
        make: 'Chevrolet',
        model: 'Malibu',
        year: 2023,
        odometerReading: 6000,
      },
      auctionInformation: {
        locationInitials: 'MAN',
        dealerNumber: '11008',
        vehiclePurchasePrice: 20000,
        saleNumber: '1008',
        laneNumber: '1',
        runNumber: '11',
      },
    },
  },
  {
    id: 'gp-9',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-09T15:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 300,
      paymentKind: 'Invoice',
      externalId: 'EXT-009',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 400,
      product: { name: 'Seller Assurance 21 days' },
      vehicleInformation: {
        vin: 'WAUFFAFL1EN036682',
        make: 'Audi',
        model: 'A4',
        year: 2022,
        odometerReading: 26000,
      },
      auctionInformation: {
        locationInitials: 'SFO',
        dealerNumber: '11009',
        vehiclePurchasePrice: 32000,
        saleNumber: '1009',
        laneNumber: '6',
        runNumber: '4',
      },
    },
  },
  {
    id: 'gp-10',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-10T10:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 375,
      paymentKind: 'Invoice',
      externalId: 'EXT-010',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 500,
      product: { name: 'DealShield 360, 21 days, 500 miles' },
      vehicleInformation: {
        vin: 'WBA3A5G51DNP26082',
        make: 'BMW',
        model: '3 Series',
        year: 2023,
        odometerReading: 11000,
      },
      auctionInformation: {
        locationInitials: 'NYC',
        dealerNumber: '11010',
        vehiclePurchasePrice: 41000,
        saleNumber: '1010',
        laneNumber: '4',
        runNumber: '18',
      },
    },
  },
  {
    id: 'gp-11',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-11T09:15:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 220,
      paymentKind: 'Credit Card',
      externalId: 'EXT-011',
      leftLot: false,
      daysSelected: 10,
      milesSelected: 250,
      product: { name: 'Seller Assurance 10 days' },
      vehicleInformation: {
        vin: '2C3CCAEG1FH774444',
        make: 'Chrysler',
        model: '300',
        year: 2020,
        odometerReading: 52000,
      },
      auctionInformation: {
        locationInitials: 'DET',
        dealerNumber: '11011',
        vehiclePurchasePrice: 17000,
        saleNumber: '1011',
        laneNumber: '3',
        runNumber: '9',
      },
    },
  },
  {
    id: 'gp-12',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-12T11:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 480,
      paymentKind: 'Invoice',
      externalId: 'EXT-012',
      leftLot: false,
      daysSelected: 45,
      milesSelected: 750,
      product: { name: 'DealShield 360, 45 days, 750 miles' },
      vehicleInformation: {
        vin: '4T1B11HK0JU044791',
        make: 'Toyota',
        model: 'Camry',
        year: 2022,
        odometerReading: 17000,
      },
      auctionInformation: {
        locationInitials: 'MAN',
        dealerNumber: '11012',
        vehiclePurchasePrice: 24000,
        saleNumber: '1012',
        laneNumber: '2',
        runNumber: '6',
      },
    },
  },
  {
    id: 'gp-13',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-13T08:45:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 340,
      paymentKind: 'Invoice',
      externalId: 'EXT-013',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 500,
      product: { name: 'Seller Assurance 21 days' },
      vehicleInformation: {
        vin: 'SALWR2FV8FA512345',
        make: 'Land Rover',
        model: 'Range Rover',
        year: 2023,
        odometerReading: 9500,
      },
      auctionInformation: {
        locationInitials: 'LAX',
        dealerNumber: '11013',
        vehiclePurchasePrice: 75000,
        saleNumber: '1013',
        laneNumber: '1',
        runNumber: '2',
      },
    },
  },
  {
    id: 'gp-14',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-14T12:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 295,
      paymentKind: 'Credit Card',
      externalId: 'EXT-014',
      leftLot: false,
      daysSelected: 14,
      milesSelected: 300,
      product: { name: 'DealShield 360, 14 days, 300 miles' },
      vehicleInformation: {
        vin: '3GNKBCRS5HS570001',
        make: 'Chevrolet',
        model: 'Equinox',
        year: 2021,
        odometerReading: 28000,
      },
      auctionInformation: {
        locationInitials: 'CHI',
        dealerNumber: '11014',
        vehiclePurchasePrice: 21000,
        saleNumber: '1014',
        laneNumber: '5',
        runNumber: '13',
      },
    },
  },
  {
    id: 'gp-15',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-15T07:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 185,
      paymentKind: 'Invoice',
      externalId: 'EXT-015',
      leftLot: false,
      daysSelected: 7,
      milesSelected: 150,
      product: { name: 'Seller Assurance 7 days' },
      vehicleInformation: {
        vin: 'KMHD04LB2HU355556',
        make: 'Hyundai',
        model: 'Elantra',
        year: 2020,
        odometerReading: 38000,
      },
      auctionInformation: {
        locationInitials: 'SEA',
        dealerNumber: '11015',
        vehiclePurchasePrice: 13500,
        saleNumber: '1015',
        laneNumber: '4',
        runNumber: '20',
      },
    },
  },
  {
    id: 'gp-16',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-16T10:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 420,
      paymentKind: 'Invoice',
      externalId: 'EXT-016',
      leftLot: false,
      daysSelected: 30,
      milesSelected: 500,
      product: { name: 'DealShield 360, 30 days, 500 miles' },
      vehicleInformation: {
        vin: '5YJSA1E26JF289007',
        make: 'Tesla',
        model: 'Model S',
        year: 2023,
        odometerReading: 5000,
      },
      auctionInformation: {
        locationInitials: 'SFO',
        dealerNumber: '11016',
        vehiclePurchasePrice: 85000,
        saleNumber: '1016',
        laneNumber: '1',
        runNumber: '1',
      },
    },
  },
  {
    id: 'gp-17',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-17T14:15:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 260,
      paymentKind: 'Credit Card',
      externalId: 'EXT-017',
      leftLot: false,
      daysSelected: 14,
      milesSelected: 350,
      product: { name: 'Seller Assurance 14 days' },
      vehicleInformation: {
        vin: 'KNDPM3AC8H7226789',
        make: 'Kia',
        model: 'Sorento',
        year: 2021,
        odometerReading: 34000,
      },
      auctionInformation: {
        locationInitials: 'ATL',
        dealerNumber: '11017',
        vehiclePurchasePrice: 25000,
        saleNumber: '1017',
        laneNumber: '3',
        runNumber: '14',
      },
    },
  },
  {
    id: 'gp-18',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-18T09:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 360,
      paymentKind: 'Invoice',
      externalId: 'EXT-018',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 500,
      product: { name: 'DealShield 360, 21 days, 500 miles' },
      vehicleInformation: {
        vin: '1C4RJFAG5EC111222',
        make: 'Jeep',
        model: 'Grand Cherokee',
        year: 2022,
        odometerReading: 23000,
      },
      auctionInformation: {
        locationInitials: 'PHX',
        dealerNumber: '11018',
        vehiclePurchasePrice: 33000,
        saleNumber: '1018',
        laneNumber: '2',
        runNumber: '16',
      },
    },
  },
  {
    id: 'gp-19',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-19T11:45:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 310,
      paymentKind: 'Invoice',
      externalId: 'EXT-019',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 400,
      product: { name: 'Seller Assurance 21 days' },
      vehicleInformation: {
        vin: '2HKRM3H71FH502233',
        make: 'Honda',
        model: 'CR-V',
        year: 2020,
        odometerReading: 41000,
      },
      auctionInformation: {
        locationInitials: 'HOU',
        dealerNumber: '11019',
        vehiclePurchasePrice: 26000,
        saleNumber: '1019',
        laneNumber: '6',
        runNumber: '19',
      },
    },
  },
  {
    id: 'gp-20',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-20T08:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 390,
      paymentKind: 'Credit Card',
      externalId: 'EXT-020',
      leftLot: false,
      daysSelected: 30,
      milesSelected: 600,
      product: { name: 'DealShield 360, 30 days, 600 miles' },
      vehicleInformation: {
        vin: '1VWSA7A30JC044411',
        make: 'Volkswagen',
        model: 'Passat',
        year: 2022,
        odometerReading: 16000,
      },
      auctionInformation: {
        locationInitials: 'NYC',
        dealerNumber: '11020',
        vehiclePurchasePrice: 22500,
        saleNumber: '1020',
        laneNumber: '4',
        runNumber: '12',
      },
    },
  },
  {
    id: 'gp-21',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-21T13:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 230,
      paymentKind: 'Invoice',
      externalId: 'EXT-021',
      leftLot: false,
      daysSelected: 10,
      milesSelected: 300,
      product: { name: 'Seller Assurance 10 days' },
      vehicleInformation: {
        vin: '3FA6P0H72HR337778',
        make: 'Ford',
        model: 'Fusion',
        year: 2021,
        odometerReading: 29000,
      },
      auctionInformation: {
        locationInitials: 'DET',
        dealerNumber: '11021',
        vehiclePurchasePrice: 16000,
        saleNumber: '1021',
        laneNumber: '3',
        runNumber: '8',
      },
    },
  },
  {
    id: 'gp-22',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-22T10:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 440,
      paymentKind: 'Invoice',
      externalId: 'EXT-022',
      leftLot: false,
      daysSelected: 45,
      milesSelected: 1000,
      product: { name: 'DealShield 360, 45 days, 1000 miles' },
      vehicleInformation: {
        vin: 'JTDKARFP0J3069445',
        make: 'Toyota',
        model: 'Prius Prime',
        year: 2023,
        odometerReading: 7000,
      },
      auctionInformation: {
        locationInitials: 'LAX',
        dealerNumber: '11022',
        vehiclePurchasePrice: 29000,
        saleNumber: '1022',
        laneNumber: '1',
        runNumber: '3',
      },
    },
  },
  {
    id: 'gp-23',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-23T07:45:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 270,
      paymentKind: 'Credit Card',
      externalId: 'EXT-023',
      leftLot: false,
      daysSelected: 14,
      milesSelected: 350,
      product: { name: 'Seller Assurance 14 days' },
      vehicleInformation: {
        vin: 'WDD2050141F787654',
        make: 'Mercedes-Benz',
        model: 'C-Class',
        year: 2022,
        odometerReading: 20000,
      },
      auctionInformation: {
        locationInitials: 'MIA',
        dealerNumber: '11023',
        vehiclePurchasePrice: 39000,
        saleNumber: '1023',
        laneNumber: '5',
        runNumber: '17',
      },
    },
  },
  {
    id: 'gp-24',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-24T09:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 330,
      paymentKind: 'Invoice',
      externalId: 'EXT-024',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 450,
      product: { name: 'DealShield 360, 21 days, 450 miles' },
      vehicleInformation: {
        vin: '5NPE34AF8JH718899',
        make: 'Hyundai',
        model: 'Sonata',
        year: 2021,
        odometerReading: 32000,
      },
      auctionInformation: {
        locationInitials: 'CHI',
        dealerNumber: '11024',
        vehiclePurchasePrice: 20500,
        saleNumber: '1024',
        laneNumber: '2',
        runNumber: '21',
      },
    },
  },
  {
    id: 'gp-25',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-25T12:15:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 195,
      paymentKind: 'Invoice',
      externalId: 'EXT-025',
      leftLot: false,
      daysSelected: 7,
      milesSelected: 200,
      product: { name: 'Seller Assurance 7 days' },
      vehicleInformation: {
        vin: 'KM8J3CA40JU778899',
        make: 'Hyundai',
        model: 'Tucson',
        year: 2022,
        odometerReading: 24000,
      },
      auctionInformation: {
        locationInitials: 'SEA',
        dealerNumber: '11025',
        vehiclePurchasePrice: 23000,
        saleNumber: '1025',
        laneNumber: '6',
        runNumber: '5',
      },
    },
  },
  {
    id: 'gp-26',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-26T10:45:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 370,
      paymentKind: 'Credit Card',
      externalId: 'EXT-026',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 500,
      product: { name: 'DealShield 360, 21 days, 500 miles' },
      vehicleInformation: {
        vin: '2GNFLEEK2H6247001',
        make: 'Chevrolet',
        model: 'Equinox',
        year: 2023,
        odometerReading: 10000,
      },
      auctionInformation: {
        locationInitials: 'DAL',
        dealerNumber: '11026',
        vehiclePurchasePrice: 26500,
        saleNumber: '1026',
        laneNumber: '4',
        runNumber: '10',
      },
    },
  },
  {
    id: 'gp-27',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-27T08:15:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 285,
      paymentKind: 'Invoice',
      externalId: 'EXT-027',
      leftLot: false,
      daysSelected: 17,
      milesSelected: 350,
      product: { name: 'Seller Assurance 17 days' },
      vehicleInformation: {
        vin: '3CZRU6H59KG702233',
        make: 'Honda',
        model: 'HR-V',
        year: 2020,
        odometerReading: 43000,
      },
      auctionInformation: {
        locationInitials: 'ATL',
        dealerNumber: '11027',
        vehiclePurchasePrice: 19000,
        saleNumber: '1027',
        laneNumber: '1',
        runNumber: '6',
      },
    },
  },
  {
    id: 'gp-28',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-28T11:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 510,
      paymentKind: 'Invoice',
      externalId: 'EXT-028',
      leftLot: false,
      daysSelected: 45,
      milesSelected: 1000,
      product: { name: 'DealShield 360, 45 days, 1000 miles' },
      vehicleInformation: {
        vin: '1G6DC5E52D0157444',
        make: 'Cadillac',
        model: 'ATS',
        year: 2022,
        odometerReading: 14000,
      },
      auctionInformation: {
        locationInitials: 'NYC',
        dealerNumber: '11028',
        vehiclePurchasePrice: 47000,
        saleNumber: '1028',
        laneNumber: '3',
        runNumber: '4',
      },
    },
  },
  {
    id: 'gp-29',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-11-29T14:30:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 240,
      paymentKind: 'Credit Card',
      externalId: 'EXT-029',
      leftLot: false,
      daysSelected: 14,
      milesSelected: 300,
      product: { name: 'Seller Assurance 14 days' },
      vehicleInformation: {
        vin: 'YV1612FH4E2295588',
        make: 'Volvo',
        model: 'S60',
        year: 2021,
        odometerReading: 36000,
      },
      auctionInformation: {
        locationInitials: 'MIA',
        dealerNumber: '11029',
        vehiclePurchasePrice: 29500,
        saleNumber: '1029',
        laneNumber: '5',
        runNumber: '23',
      },
    },
  },
  {
    id: 'gp-30',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-11-30T09:00:00Z',
    expireGuarantee: false,
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'active',
      guaranteePrice: 355,
      paymentKind: 'Invoice',
      externalId: 'EXT-030',
      leftLot: false,
      daysSelected: 21,
      milesSelected: 500,
      product: { name: 'DealShield 360, 21 days, 500 miles' },
      vehicleInformation: {
        vin: '19XFB2F59CE030099',
        make: 'Honda',
        model: 'Civic',
        year: 2023,
        odometerReading: 4500,
      },
      auctionInformation: {
        locationInitials: 'HOU',
        dealerNumber: '11030',
        vehiclePurchasePrice: 21000,
        saleNumber: '1030',
        laneNumber: '2',
        runNumber: '15',
      },
    },
  },
];

// ---------------------------------------------------------------------------
// Cancelled Purchases
// ---------------------------------------------------------------------------
export const mockCancelledPurchases = [
  {
    id: 'cp-1',
    buyerEmail: 'buyer1@example.com',
    cancellingUserName: 'admin_user1',
    auctionAccessNo: 'AA-10001',
    dealerNo: '21001',
    vin: '1HGBH41JXMN200001',
    universalNo: 'UNI-1001',
    guaranteeDaysSelected: 21,
    guaranteeMilesSelected: 500,
    guaranteeIfBid: true,
    guaranteeSellerPaid: false,
    automaticPurchase: false,
    vehiclePurchasePrice: 18000,
    guaranteePrice: 300,
    inspectionPrice: 150,
    cancellationDate: '2025-10-15',
    cancellationReason: 'Customer Request',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-2',
    buyerEmail: 'buyer2@example.com',
    cancellingUserName: 'admin_user2',
    auctionAccessNo: 'AA-10002',
    dealerNo: '21002',
    vin: '2T1BURHE0JC200002',
    universalNo: 'UNI-1002',
    guaranteeDaysSelected: 30,
    guaranteeMilesSelected: 750,
    guaranteeIfBid: false,
    guaranteeSellerPaid: true,
    automaticPurchase: false,
    vehiclePurchasePrice: 22000,
    guaranteePrice: 400,
    inspectionPrice: 200,
    cancellationDate: '2025-10-16',
    cancellationReason: 'Vehicle Condition',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-3',
    buyerEmail: 'buyer3@example.com',
    cancellingUserName: 'admin_user3',
    auctionAccessNo: 'AA-10003',
    dealerNo: '21003',
    vin: '3VWFE21C04M200003',
    universalNo: 'UNI-1003',
    guaranteeDaysSelected: 14,
    guaranteeMilesSelected: 300,
    guaranteeIfBid: true,
    guaranteeSellerPaid: true,
    automaticPurchase: true,
    vehiclePurchasePrice: 15000,
    guaranteePrice: 250,
    inspectionPrice: 100,
    cancellationDate: '2025-10-17',
    cancellationReason: 'Title Issue',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-4',
    buyerEmail: 'buyer4@example.com',
    cancellingUserName: 'admin_user1',
    auctionAccessNo: 'AA-10004',
    dealerNo: '21004',
    vin: '1N4AL3AP7JC200004',
    universalNo: 'UNI-1004',
    guaranteeDaysSelected: 21,
    guaranteeMilesSelected: 500,
    guaranteeIfBid: false,
    guaranteeSellerPaid: false,
    automaticPurchase: false,
    vehiclePurchasePrice: 25000,
    guaranteePrice: 350,
    inspectionPrice: 175,
    cancellationDate: '2025-10-18',
    cancellationReason: 'Duplicate Entry',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: { guaranteeStatus: 'reinstating' },
  },
  {
    id: 'cp-5',
    buyerEmail: 'buyer5@example.com',
    cancellingUserName: 'admin_user4',
    auctionAccessNo: 'AA-10005',
    dealerNo: '21005',
    vin: '5FNRL5H61GB200005',
    universalNo: 'UNI-1005',
    guaranteeDaysSelected: 10,
    guaranteeMilesSelected: 250,
    guaranteeIfBid: true,
    guaranteeSellerPaid: true,
    automaticPurchase: false,
    vehiclePurchasePrice: 32000,
    guaranteePrice: 420,
    inspectionPrice: 220,
    cancellationDate: '2025-10-19',
    cancellationReason: 'Customer Request',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-6',
    buyerEmail: 'buyer6@example.com',
    cancellingUserName: 'admin_user2',
    auctionAccessNo: 'AA-10006',
    dealerNo: '21006',
    vin: 'JN8AT2MT4JW200006',
    universalNo: 'UNI-1006',
    guaranteeDaysSelected: 45,
    guaranteeMilesSelected: 1000,
    guaranteeIfBid: false,
    guaranteeSellerPaid: false,
    automaticPurchase: true,
    vehiclePurchasePrice: 28000,
    guaranteePrice: 460,
    inspectionPrice: 230,
    cancellationDate: '2025-10-20',
    cancellationReason: 'Vehicle Sold',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-7',
    buyerEmail: 'buyer7@example.com',
    cancellingUserName: 'admin_user3',
    auctionAccessNo: 'AA-10007',
    dealerNo: '21007',
    vin: '1FTFW1ET2DFA00007',
    universalNo: 'UNI-1007',
    guaranteeDaysSelected: 14,
    guaranteeMilesSelected: 300,
    guaranteeIfBid: true,
    guaranteeSellerPaid: true,
    automaticPurchase: false,
    vehiclePurchasePrice: 40000,
    guaranteePrice: 380,
    inspectionPrice: 190,
    cancellationDate: '2025-10-21',
    cancellationReason: 'Fraud',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-8',
    buyerEmail: 'buyer8@example.com',
    cancellingUserName: 'admin_user1',
    auctionAccessNo: 'AA-10008',
    dealerNo: '21008',
    vin: '1G1ZD5ST2JF200008',
    universalNo: 'UNI-1008',
    guaranteeDaysSelected: 21,
    guaranteeMilesSelected: 500,
    guaranteeIfBid: false,
    guaranteeSellerPaid: false,
    automaticPurchase: false,
    vehiclePurchasePrice: 19500,
    guaranteePrice: 310,
    inspectionPrice: 155,
    cancellationDate: '2025-10-22',
    cancellationReason: 'Customer Request',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-9',
    buyerEmail: 'buyer9@example.com',
    cancellingUserName: 'admin_user4',
    auctionAccessNo: 'AA-10009',
    dealerNo: '21009',
    vin: 'WAUFFAFL1EN0 00009',
    universalNo: 'UNI-1009',
    guaranteeDaysSelected: 30,
    guaranteeMilesSelected: 600,
    guaranteeIfBid: true,
    guaranteeSellerPaid: true,
    automaticPurchase: true,
    vehiclePurchasePrice: 33000,
    guaranteePrice: 440,
    inspectionPrice: 210,
    cancellationDate: '2025-10-23',
    cancellationReason: 'Title Issue',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
  {
    id: 'cp-10',
    buyerEmail: 'buyer10@example.com',
    cancellingUserName: 'admin_user2',
    auctionAccessNo: 'AA-10010',
    dealerNo: '21010',
    vin: 'WBA3A5G51DNP00010',
    universalNo: 'UNI-1010',
    guaranteeDaysSelected: 21,
    guaranteeMilesSelected: 500,
    guaranteeIfBid: false,
    guaranteeSellerPaid: false,
    automaticPurchase: false,
    vehiclePurchasePrice: 43000,
    guaranteePrice: 520,
    inspectionPrice: 260,
    cancellationDate: '2025-10-24',
    cancellationReason: 'Vehicle Condition',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: { guaranteeStatus: 'cancelled' },
  },
];

// ---------------------------------------------------------------------------
// Ineligible Purchases
// ---------------------------------------------------------------------------
export const mockIneligiblePurchases = [
  {
    id: 'ip-1',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-10-01T10:00:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Vehicle age exceeds maximum',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-001',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: '1HGBH41JXMN300001',
        make: 'Ford',
        model: 'Explorer',
        year: 2009,
        odometerReading: 180000,
      },
      auctionInformation: {
        locationInitials: 'MAN',
        dealerNumber: '31001',
        vehiclePurchasePrice: 5000,
        saleNumber: '3001',
        laneNumber: '1',
        runNumber: '1',
      },
    },
  },
  {
    id: 'ip-2',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-10-02T11:30:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Odometer exceeds limit',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-002',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: '2T1BURHE0JC300002',
        make: 'Chevrolet',
        model: 'Silverado',
        year: 2015,
        odometerReading: 210000,
      },
      auctionInformation: {
        locationInitials: 'DAL',
        dealerNumber: '31002',
        vehiclePurchasePrice: 8000,
        saleNumber: '3002',
        laneNumber: '2',
        runNumber: '5',
      },
    },
  },
  {
    id: 'ip-3',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-10-03T09:15:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Salvage title',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-003',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: '3VWFE21C04M300003',
        make: 'Dodge',
        model: 'Ram 1500',
        year: 2018,
        odometerReading: 95000,
      },
      auctionInformation: {
        locationInitials: 'CHI',
        dealerNumber: '31003',
        vehiclePurchasePrice: 12000,
        saleNumber: '3003',
        laneNumber: '3',
        runNumber: '8',
      },
    },
  },
  {
    id: 'ip-4',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-10-04T14:00:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Dealer not enrolled',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-004',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: '1N4AL3AP7JC300004',
        make: 'Nissan',
        model: 'Frontier',
        year: 2017,
        odometerReading: 88000,
      },
      auctionInformation: {
        locationInitials: 'ATL',
        dealerNumber: '31004',
        vehiclePurchasePrice: 11000,
        saleNumber: '3004',
        laneNumber: '4',
        runNumber: '11',
      },
    },
  },
  {
    id: 'ip-5',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-10-05T08:45:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Vehicle price too high',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-005',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: '5FNRL5H61GB300005',
        make: 'Ferrari',
        model: '488 GTB',
        year: 2019,
        odometerReading: 12000,
      },
      auctionInformation: {
        locationInitials: 'MIA',
        dealerNumber: '31005',
        vehiclePurchasePrice: 250000,
        saleNumber: '3005',
        laneNumber: '1',
        runNumber: '2',
      },
    },
  },
  {
    id: 'ip-6',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-10-06T12:30:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Missing VIN',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-006',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: 'UNKNOWN',
        make: 'Unknown',
        model: 'Unknown',
        year: 2020,
        odometerReading: 0,
      },
      auctionInformation: {
        locationInitials: 'HOU',
        dealerNumber: '31006',
        vehiclePurchasePrice: 0,
        saleNumber: '3006',
        laneNumber: '5',
        runNumber: '16',
      },
    },
  },
  {
    id: 'ip-7',
    kind: 'purchase_protect',
    partner: 'ADESA',
    guaranteedAt: '2025-10-07T10:00:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Blacklisted VIN',
    productFamily: PRODUCT_FAMILY_DEALSHIELD,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-007',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: 'JN8AT2MT4JW300007',
        make: 'Infiniti',
        model: 'QX60',
        year: 2021,
        odometerReading: 42000,
      },
      auctionInformation: {
        locationInitials: 'NYC',
        dealerNumber: '31007',
        vehiclePurchasePrice: 38000,
        saleNumber: '3007',
        laneNumber: '2',
        runNumber: '7',
      },
    },
  },
  {
    id: 'ip-8',
    kind: 'purchase_protect',
    partner: 'Manheim',
    guaranteedAt: '2025-10-08T15:00:00Z',
    expireGuarantee: false,
    ineligibilityReason: 'Auction not supported',
    productFamily: PRODUCT_FAMILY_SA,
    guaranteeOffer: {
      guaranteeStatus: 'ineligible',
      guaranteePrice: 0,
      paymentKind: 'N/A',
      externalId: 'INELG-008',
      leftLot: false,
      daysSelected: 0,
      milesSelected: 0,
      product: null,
      vehicleInformation: {
        vin: '1FTFW1ET2DFA00008',
        make: 'Ford',
        model: 'Mustang',
        year: 2022,
        odometerReading: 11000,
      },
      auctionInformation: {
        locationInitials: 'SEA',
        dealerNumber: '31008',
        vehiclePurchasePrice: 35000,
        saleNumber: '3008',
        laneNumber: '3',
        runNumber: '9',
      },
    },
  },
];
